import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=7a5c6a8c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5c6a8c')) {
      api.createRecord('7a5c6a8c', component.options)
    } else {
      api.reload('7a5c6a8c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=7a5c6a8c&", function () {
      api.rerender('7a5c6a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CwgHlJIak6AM/JS/imageCarousel.vue"
export default component.exports